import Vue from 'vue'
import store from '@/store'
import { CHECK_AUTH } from '@/store/modules/authentication'

import Router from 'vue-router'
import Index from '@/views/dashboard/Index.vue'
import MyInspection from '@/views/my-inspection/Index.vue'
import NotFound from '@/views/NotFound.vue'

import AuthRoutes from '@/router/modules/auth'
import UserRoutes from '@/router/modules/users'
import RoleRoutes from '@/router/modules/roles'
import CompanyRoutes from '@/router/modules/companies'
import ProjectRoutes from '@/router/modules/projects'
import ScheduleRoutes from '@/router/modules/schedule'
import InspectionRoutes from '@/router/modules/inspections'
import OnlineDossier from '@/router/modules/online-dossier'

import { SET_TAGS } from '../store/modules/tags'

Vue.use(Router)

const baseRoutes = [
	{
		path: '/',
		name: 'home',
		component: Index,
		meta: {
			title: 'Home',
			requiresAuth: true
		},
	},
	{
		path: '/mijn-opname',
		name: 'myInspection',
		component: MyInspection,
		meta: {
			title: 'Mijn opname',
			requiresAuth: false,
			objectOwnerPage: true,
		},
	},
]

const routes = baseRoutes.concat(AuthRoutes, UserRoutes, RoleRoutes, CompanyRoutes, ProjectRoutes, ScheduleRoutes, InspectionRoutes, OnlineDossier, [
	{ path: '*', component: NotFound },
])

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: routes,
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title + ' | TB Expertise | Opnameplatform'

	to.matched.some((record) => {
		if (record.meta.onlineDossier) {
			return Promise.resolve(next())
		}

		if (record.meta.requiresAuth) {
			if (store.getters.isAuthenticated !== true) {
				next({
					path: '/login',
					params: { nextUrl: to.fullPath },
				})
			} else {
				if (record.meta.onlineProjectDossier) {
					return Promise.resolve(next())
				}
			}
		}

		if (!record.meta.requiresAuth) {
			if (store.getters.isAuthenticated === true) {
				next({
					path: '/',
					params: { nextUrl: to.fullPath },
				})
			}
		}
	})

	store.dispatch(SET_TAGS, [])

	return Promise.all([store.dispatch(CHECK_AUTH)]).then(next)
})

export default router